<template>
   <div>
       <b-text-field v-bind="$props" v-model="lazyValue">
           <template v-slot:prepend-inner>
               <v-menu
                   v-model="menu"
                   :close-on-content-click="false"
                   :nudge-width="300"
                   offset-y

               >
                   <template v-slot:activator="{ on, attrs }">
                       <a
                           v-bind="attrs"
                           v-on="on"
                       >
                           <Flag :code="countryCode" />
                           <v-icon>mdi-chevron-down</v-icon>
                       </a>
                   </template>

                   <v-card :loading="menuLoading" :disabled="menuLoading">
                       <v-card-title>Selecteer een land</v-card-title>
                       <v-card-text>
                           <v-btn v-for="country in quickSelectCountries" :key="country.id" class="mr-2"
                                  color="primary"
                                  outlined small :value="country.id" @click.prevent="selectedCountry = country.id">
                               <Flag :code="country.code" class="mr-2" /> {{ country.code }}
                           </v-btn>
                           <v-divider class="my-2"></v-divider>
                           <SelectCountry v-model="selectedCountry" :append="entry => '+' + entry.phone_code" />
                       </v-card-text>
                       <v-card-actions>
                           <v-spacer></v-spacer>
                           <v-btn text @click="closeMenu">
                               Sluiten
                           </v-btn>
                       </v-card-actions>
                   </v-card>
               </v-menu>
           </template>
           <template v-slot:append>
               <v-icon v-if="isValid" color="success">mdi-check</v-icon>
           </template>
       </b-text-field>
   </div>
</template>

<script>
import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
import PropsMixin from "@/components/General/Form/Mixin/PropsMixin";
import BTextField from "@/components/General/Form/BTextField";
import {getCountryCallingCode, AsYouType, parsePhoneNumber} from 'libphonenumber-js';
import PhoneService from "@/utils/Services/PhoneService";
import Flag from "@/components/General/Icon/Flag";
import Country from "@/models/Country/Country";
import SelectCountry from "@/components/General/Form/Select/SelectCountry";

export default {
    components: {SelectCountry, Flag, BTextField},
    mixins: [PropsMixin, VuelidateMixin],
    props: {
        placeholder: {
            default: '+31000000000',
        }
    },
    data() {
        return {
            countryCode: null,
            isValid: false,
            menu: false,
            menuLoading: false,
            selectedCountry: null,
            quickSelectCountries: [],
        }
    },
    computed: {
        lazyValue: {
            get() {
                if (!this.value) {
                    return '';
                }

                return (this.value + '').replace(/^00+/, '+');
            },
            set(val) {
                if (val) {
                    val = val.replace("+", "00");
                    val = val.replace(/[^0-9]/ig,'');
                    val = PhoneService.formatUnknownCountry(val);
                }

                this.$emit('input', val);
            }
        },
    },
    watch: {
        selectedCountry(countryId) {
            if (!countryId) {
                return;
            }
            this.menuLoading = true;
            Country.api().find(countryId).then(country => {
                this.setCountry(country.code);
                this.menuLoading = false;
                this.closeMenu();
            });
        },
        value: {
            immediate: true,
            handler(val) {
                this.countryCode = null;
                this.isValid = false;
                let parsed = (val + '').replace(/^00+/, '+');
                let ayt = new AsYouType();
                ayt.input(parsed);

                if (ayt.getCountry()) {
                    this.countryCode = ayt.getCountry();
                    this.isValid = ayt.isValid();
                }
            }
        },
    },
    methods: {
        closeMenu() {
            this.selectedCountry = null;
            this.menu = false;
        },
        async setQuickSelectCountries() {
            this.quickSelectCountries = await Country.api().where('codeIn', ['NL', 'BE', 'DE']).get();
        },
        setCountry(countryCode) {
            const newCountryCallingCode = '+' + getCountryCallingCode(countryCode);
            if (this.countryCode) {
                const currentCountryCallingCode = '+' + getCountryCallingCode(this.countryCode);
                this.lazyValue = this.lazyValue.replace(currentCountryCallingCode, newCountryCallingCode);
                return;
            }

            try {
                this.lazyValue = parsePhoneNumber(this.lazyValue, countryCode).number;
            } catch {
                this.lazyValue = newCountryCallingCode;
            }
        }
    },
    created() {
        this.setQuickSelectCountries();
    }
}
</script>
